import {
  Type,
  playerFailure,
  insertSuccess,
  playbetweenSuccess,
  playSuccess,
  pauseSuccess,
  setPositionSuccess,
  stepSuccess,
  setMarkSuccess,
  getPositionSuccess,
} from './actions';
import { takeLatest, all, call, put, takeLeading } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import {
  PlayerService,
  Actions as PlayerActions,
} from 'services/PlayerService';

import api from 'services/api';
export function* insert({ payload }) {
  try {
    const { playerADX, pendente } = payload;
    const cmd = PlayerService(PlayerActions.INSERT, payload);
    const data = Object.assign({
      cmd,
      pendente_id: pendente.id,
    });
    const response = yield call(api.post, `/playeradx/${playerADX.id}`, data, {
      timeout: 4000,
    });
    yield put(insertSuccess(response.data));
    // yield put(insertSuccess())
  } catch (error) {
    console.log(error);
    if (error.response?.data?.message) {
      toast.error(error.response.data.message);
      yield put(playerFailure(error.response.data.message));
    }
  }
}

export function* play({ payload }) {
  try {
    const { idPlayer, command } = payload;
    const cmd = PlayerService(command);
    yield call(
      api.post,
      `/playeradx/${idPlayer}`,
      { cmd },
      {
        timeout: 4000,
      },
    );
    yield put(playSuccess());
  } catch (error) {
    console.log(error);
    if (error.response?.data?.message) {
      toast.error(error.response.data.message);
      yield put(playerFailure(error.response.data.message));
    }
  }
}

export function* playbetween({ payload }) {
  try {
    const { playerADX } = payload;
    const cmd = PlayerService(PlayerActions.PLAYBETWEEN);

    const response = yield call(
      api.post,
      `/playeradx/${playerADX.id}`,
      { cmd },
      {
        timeout: 4000,
      },
    );
    yield put(playbetweenSuccess(response.data));
  } catch (error) {
    console.log(error);
    if (error.response?.data?.message) {
      toast.error(error.response.data.message);
      yield put(playerFailure(error.response.data.message));
    }
  }
}

export function* pause({ payload }) {
  try {
    const { playerADX } = payload;
    const cmd = PlayerService(PlayerActions.PAUSE);

    yield call(
      api.post,
      `/playeradx/${playerADX.id}`,
      { cmd },
      {
        timeout: 4000,
      },
    );
    yield put(pauseSuccess());
  } catch (error) {
    console.log(error);
    if (error.response?.data?.message) {
      toast.error(error.response.data.message);
      yield put(playerFailure(error.response.data.message));
    }
  }
}

export function* setPosition({ payload }) {
  const { idPlayer, position, command } = payload;

  try {
    const cmd = PlayerService(command, null, position);
    yield call(
      api.post,
      `/playeradx/${idPlayer}`,
      { cmd },
      {
        timeout: 4000,
      },
    );
    yield put(setPositionSuccess({ current: position }));
  } catch (error) {
    if (command.includes('setfragment')) {
      // yield put(playerFailure(error.response.data.message))
    } else if (error.response?.data?.message) {
      toast.error(error.response.data.message);
      yield put(playerFailure(error.response.data.message));
    }
  }
}

export function* setStep({ payload }) {
  try {
    const { idPlayer, command } = payload;
    const cmd = PlayerService(command);
    const response = yield call(
      api.post,
      `/playeradx/${idPlayer}`,
      { cmd },
      {
        timeout: 4000,
      },
    );

    yield put(stepSuccess(response.data));
  } catch (error) {
    console.log(error);
    if (error.response?.data?.message) {
      toast.error(error.response.data.message);
      yield put(playerFailure(error.response.data.message));
    }
  }
}

export function* setMark({ payload }) {
  try {
    const { idPlayer, command } = payload;
    const cmd = PlayerService(command);
    const response = yield call(
      api.post,
      `/playeradx/${idPlayer}`,
      { cmd },
      {
        timeout: 4000,
      },
    );

    yield put(setMarkSuccess(response.data));
  } catch (error) {
    console.log(error);
    if (error.response?.data?.message) {
      toast.error(error.response.data.message);
      yield put(playerFailure(error.response.data.message));
    }
  }
}

export function* getPosition({ payload }) {
  try {
    const { idPlayer, command } = payload;
    const cmd = PlayerService(command);
    const response = yield call(
      api.post,
      `/playeradx/${idPlayer}`,
      { cmd },
      { timeout: 100 },
    );
    yield put(getPositionSuccess(response.data));
  } catch (error) {
    console.log(error);
    // toast.error(error.response.data.message)
    // yield put(playerFailure(error.response.data.message))
  }
}

export default all([
  takeLeading(Type.INSERT_REQUEST, insert),
  takeLeading(Type.PLAY_REQUEST, play),
  takeLeading(Type.PLAYBETWEEN_REQUEST, playbetween),
  takeLeading(Type.PAUSE_REQUEST, pause),
  takeLeading(Type.SETPOSITION_REQUEST, setPosition),
  takeLeading(Type.STEP_REQUEST, setStep),
  takeLatest(Type.SETMARK_REQUEST, setMark),
  takeLeading(Type.GETPOSITION_REQUEST, getPosition),
]);
